// extracted by mini-css-extract-plugin
module.exports = {"container":"Jumbotron_container__2pDm5","ko":"Jumbotron_ko__1gVpT","sub":"Jumbotron_sub__12zVA"};